module.exports = "https://web-assets.ifttt.com/packs/media/prosumer/svg--home--circle-8e9b2062.svg";